
/**
 * Normalizes a string by removing whitespace and converting to lowercase.
 *
 * @param string String to normalize.
 * @returns Lowercase trimmed string.
 */
export function normalizeString(string: string): string {
  return string.trim().toLowerCase();
}
